import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "blockContainer",
  data: {
    styles: {
      alignContent: "flex-end",
      maxHeight: "353px",
    },
    block: {
      type: "image",
      options: {
        src: `${config.ASSETS_URL}/03/case-01/principle/4-3.png`,
      },
    },
  },
};

export default component;
